import { TELEGRAM_CODE_KEY } from './getOAuthDataFromURL';

// the telegram oauth secret arrives in the url hash and must not be
// forwarded to other origins (e.g. as the sso sign-in referrer)
export const getUrlWithoutTelegramSecret = (href: string): string => {
  const url = new URL(href);
  const hashParams = new URLSearchParams(url.hash.slice(1));

  if (!hashParams.has(TELEGRAM_CODE_KEY)) {
    return href;
  }

  hashParams.delete(TELEGRAM_CODE_KEY);
  url.hash = hashParams.toString();

  return url.toString();
};
